import { render, staticRenderFns } from "./practice.vue?vue&type=template&id=ebee3cfe&scoped=true&"
import script from "./practice.vue?vue&type=script&lang=js&"
export * from "./practice.vue?vue&type=script&lang=js&"
import style0 from "./practice.vue?vue&type=style&index=0&id=ebee3cfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebee3cfe",
  null
  
)

export default component.exports